import React, { useState } from "react"
import { FaSpinner } from "react-icons/fa"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"

import { getWebmailUrl } from "@fuse/utils/emailUtils"

interface AskEmailPopupProps {
  isLoading?: boolean
  onVerifyEmail: (v: string) => void
  isEmailInboxVerification: boolean
  onResendMail: () => void
  onCloseDetailRowPopup: () => void
}

const AskEmailPopup: React.FC<AskEmailPopupProps> = ({
  isLoading,
  onVerifyEmail,
  isEmailInboxVerification,
  onResendMail,
  onCloseDetailRowPopup,
}) => {
  const [email, setEmail] = useState<string>("")
  const [error, setError] = useState<string>("")

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleSubmit = () => {
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.")
      return
    }
    setError("")
    onVerifyEmail(email)
  }

  if (isEmailInboxVerification) {
    return (
      <div
        className="flex flex-col items-center justify-center min-h-screen w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-[90%] max-w-lg bg-black backdrop-blur-md rounded-2xl p-10 space-y-6">
          {/* Title */}
          <div className="text-center">
            <h2 className="text-white text-2xl font-semibold">
              Verify your email
            </h2>

            <p className="text-white mt-2 text-sm">
              We sent an email to <br />
              <span className="font-semibold">{email}</span> <br />
              <br />
              Just click on the button in that email to complete your sign up.
            </p>
          </div>

          <div className="w-full flex items-center justify-center">
            <Button
              className="w-full bg-white/20 text-white py-2 rounded-full transition text-sm max-w-72 self-center"
              onClick={() => {
                const webmailUrl = getWebmailUrl(email)
                window.open(webmailUrl, "_blank")
              }}
            >
              Open email app
            </Button>
          </div>

          <p className="text-white text-sm">
            Haven't received email?{" "}
            <span className="underline cursor-pointer" onClick={onResendMail}>
              Resend
            </span>
          </p>

          <p className="text-white/35 text-sm">
            Didn't received email? Check your spam folder,
            <br />
            or try another email address
          </p>
        </div>
      </div>
    )
  } else {
    return (
      <div
        className="flex flex-col items-center justify-center min-h-screen w-full"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onCloseDetailRowPopup()
          }
        }}
      >
        <div className="w-[90%] max-w-lg bg-black backdrop-blur-md rounded-2xl p-10 space-y-6">
          {/* Title */}
          <div className="text-left">
            <h2 className="text-white text-2xl font-semibold">Email</h2>

            <p className="text-white mt-2 text-sm">
              Manage your email to ensure contact information is correct and
              up-to-date.
            </p>
          </div>

          <div className="flex flex-col items-center gap-2 pb-8">
            <div className="px-4 bg-white/20 h-12 rounded-md flex w-full items-center">
              <input
                type="text"
                placeholder="e.g. john@gmail.com"
                className="w-full h-full bg-transparent text-white text-[15px] placeholder-white/35 outline-none px-2"
                autoFocus
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {error && (
              <div className="text-red-500 text-sm mt-2 text-start self-start">
                {error}
              </div>
            )}
          </div>

          <Button
            className="w-full bg-white/20 text-white py-3 rounded-full font-medium transition"
            onClick={() => {
              handleSubmit()
            }}
          >
            Verify
          </Button>
        </div>
      </div>
    )
  }
}

export default AskEmailPopup
